import * as React from "react";
import { LabelledElement } from "../../labelled-element/LabelledElement.component";
import { WebcamPreview } from "../../webcam-preview/WebcamPreview.component";
import { useEffect, useState } from "react";
import { useMediaDevicesStore } from "../../../store/media-devices.store";
import { closeMenuDelayed, createDeviceOptions } from "../device-settings.util";
import Select from "react-select";
import { getReactSelectStyleClasses } from "../../../style/style-functions";
import { WarningDisplay } from "../../warning-display/WarningDisplay.component";
import { PreferenceCheckbox } from "../../preference-inputs/preference-checkbox/PreferenceCheckbox.component";
import { HTMLTooltipWrapper } from "../../html-tooltip/HTMLTooltipWrapper.component";
import { useTranslation } from "react-i18next";
import { localStreamingService } from "../../../../modules/multiplayer/peer";
import { WebcamBackgroundSettings } from "./WebcamBackgroundSettings.component";
export function CameraSelect({ noPrivacyWarning = false, noExtendedSettings = false }) {
    const [cameraOptions, setCameraOptions] = useState([]);
    const [cameraOption, setCameraOption] = useState(undefined);
    const [menuOpen, setMenuOpen] = useState(false);
    const [warningDismissed, setWarningDismissed] = useState(false);
    const mediaDevices = useMediaDevicesStore();
    const { t } = useTranslation();
    useEffect(() => {
        localStreamingService.getCameraDevices()
            .then((devices) => {
            if (devices && devices.length > 0) {
                setCameraOptions(devices);
            }
        })
            .catch((err) => {
            console.error("Error fetching camera devices:", err);
        });
    }, []);
    useEffect(() => {
        if (cameraOptions.length > 0) {
            setCameraOption(cameraOptions.find((d) => d.deviceId === mediaDevices.cam.deviceId));
        }
    }, [cameraOptions]);
    const onCamSelectChanged = (option) => {
        setCameraOption(cameraOptions.find((d) => d.deviceId === (option === null || option === void 0 ? void 0 : option.value)));
        mediaDevices.cam.setDeviceId(option === null || option === void 0 ? void 0 : option.value, true);
        // Needed to prevent the popup (MainView) from closing (otherwise the menu is removed from dom too early and the click is interpreted as outside the popup)
        closeMenuDelayed(setMenuOpen);
    };
    return (React.createElement("section", { className: "settings-outer-container" },
        mediaDevices.cam.enabled && !noPrivacyWarning && !warningDismissed && (React.createElement("div", { className: "settings-container-fixed" },
            React.createElement(WarningDisplay, { linkText: t("settings:video-currently-streaming-hint-disable-link", "Disable now"), onLinkClicked: () => {
                    mediaDevices.cam.setEnabled(false);
                }, onCloseClicked: () => {
                    setWarningDismissed(true);
                } },
                React.createElement("span", null, t("settings:video-currently-streaming-hint-line1", "Your video is currently being streamed to other users.")),
                React.createElement("span", null, t("settings:video-currently-streaming-hint-line2", "If you want to preview the camera selection without being seen, please disable your videostream first."))),
            React.createElement("div", { className: "settings-empty-row" }))),
        React.createElement("div", { className: "settings-container" },
            React.createElement("div", { className: "settings-centered-row" },
                React.createElement(WebcamPreview, { overrideDeviceEnabling: true })),
            React.createElement(HTMLTooltipWrapper, { tooltip: t("settings:select-camera-stream-tooltip", "Select the camera you want to use for your video stream") },
                React.createElement(LabelledElement, { label: t("settings:select-camera-stream", "Camera") },
                    React.createElement(Select, { onChange: onCamSelectChanged, value: cameraOption ? { value: cameraOption.deviceId, label: cameraOption.label } : undefined, options: createDeviceOptions(cameraOptions), menuIsOpen: menuOpen, onMenuOpen: () => {
                            setMenuOpen(true);
                        }, onMenuClose: () => {
                            closeMenuDelayed(setMenuOpen);
                        }, classNames: getReactSelectStyleClasses(), menuPlacement: "auto", menuPortalTarget: document.body }))),
            !noExtendedSettings && (React.createElement(PreferenceCheckbox, { label: t("settings:checkbox-enable-cam-on-start", "Enable camera on startup"), preferenceName: "cameraDefaultEnabled", tooltip: t("settings:checkbox-enable-cam-on-start-tooltip", "Enable this option to automatically enable your camera when entering a session") })),
            !noExtendedSettings && React.createElement(WebcamBackgroundSettings, null))));
}
